module.exports = {
  footerText: 'Copyright Company Name © 2018',
  socketURL : "/",
  // baseURL: `http://localhost:9005/v1/`,
   baseURL: `/v1/`,
}
